class Infrastructure {
  constructor(obj) {
    Object.assign(this, obj);
  }
}

export default Infrastructure;
